import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CarrierMapService,
  PlaceModel,
  LatLonModel,
  TrackingModel,
  VehiclesMapModel
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class CarrierMapApiService {
  constructor(private apiService: CarrierMapService) {}

  public getDistancesBetweenCoordinates(latLonModel: LatLonModel[], vehiclesMap?: boolean, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PlaceModel[]> {
    return this.apiService.carrierMapDistanceGet(latLonModel, vehiclesMap, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getPlace(latLonModel: LatLonModel, vehiclesMap?: boolean, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PlaceModel> {
    return this.apiService.carrierMapPlaceGet(latLonModel, vehiclesMap, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getTracking(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<TrackingModel> {
    return this.apiService.carrierMapTrackingGet(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getVehiclesMap(requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<VehiclesMapModel[]> {
    return this.apiService.carrierMapVehiclesGet(requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
